import {InitPage} from "../../index";

declare var App: any;
declare var storeLocation: string;
declare var productionId: number;
declare var productionRunning: string;

export class ELCProductionsLiveAlarm {
    elcLiveEmployeeChannel: any;
    audio: any;
    stopFlag: any;
    colorCounter: any;
    soundCounter: any;

    constructor() {
        this.stopFlag = true;
        this.elcLiveEmployeeChannel = App.cable.subscriptions.create(
            {
              channel: "ELC::ProductionAlarmChannel",
              tenant: storeLocation,
              production_id: productionId
            },
            {
              connected() { console.log("ELCProductionsLiveAlarm") },
              disconnected() { /* Called when the subscription has been terminated by the server */ },
              received: (data: any) => this.initiateAlarm(data)
            }
        );
    }

    initiateAlarm(data) {
        this.colorCounter = 15;
        this.soundCounter = 3;
        console.log(data);
        $("#live_active_alarms").text(data.live_active_alarms);
         if(data.change_color) {
            this.changeColor(data.alarm_div_id, true);
        } else {
            if(data.alarm_div_id) {
                this.changeColor(data.alarm_div_id, false);
            }
        }
        this.soundAlarm(data.sound_alarm);
    }

    soundAlarm(play: boolean) {
        this.soundCounter--;
        let _this = this;
        console.log(play)
            // let audio = document.getElementById("productionSoundAlarm") as HTMLAudioElement;
            // audio.autoplay = true;
            // audio.load();
            // audio.play();
            var x = document.createElement("AUDIO") as HTMLAudioElement;
            x.setAttribute("id", "myVideo");
            x.setAttribute("controls", "controls");

            var z = document.createElement("SOURCE");
            z.setAttribute("src", "/sounds/bulletin.mp3");
            z.setAttribute("type", "audio/mpeg");
            x.appendChild(z);

           // document.body.appendChild(x);

            // Set the autoplay property:
            //x.autoplay = play;
            if(play)
            {
                if(this.soundCounter > 0 )
                setTimeout(function(){
                    _this.soundAlarm(play);
                }, 6000);
                x.play();
            }
            else
                x.pause();

    }

    changeColor(html_id: string, enable: boolean) {
        this.colorCounter--;
        let _this = this;
        if(enable) {
            if(this.colorCounter > 0 )
                setTimeout(function(){
                    _this.changeColor(html_id, enable);
                }, 1100);
            $(`#${html_id}`).toggleClass("elc_alarm_color");
            if(this.colorCounter == 0)
                $(`#${html_id}`).addClass("elc_alarm_color");
        } else {
            $(`#${html_id}`).removeClass("elc_alarm_color");
        }
    }

    showAlarm()
    {
        const _this = this;
        if(_this.stopFlag)
        {
            _this.changeColor('production_cell', false);
            _this.soundAlarm(false);
        }
        else
        {
            setTimeout(function(){
                _this.changeColor('production_cell', true);
                _this.soundAlarm(true);
                _this.showAlarm();
            }, 1000);
        }
    }

    turnOnAlarm()
    {
        const _this = this
        _this.stopFlag = false;
        _this.showAlarm();
    }

    turnOffAlarm()
    {
        const _this = this
        _this.stopFlag = true;
        _this.showAlarm();

    }
}

declare global {
    interface Window {
        ELCProductionsLiveAlarm: ELCProductionsLiveAlarm;
    }
}

export function LoadPage() {
    InitPage("elc productions", () => {
        InitPage("cards index", () => {
            const c = new ELCProductionsLiveAlarm();
            window.ELCProductionsLiveAlarm = c;
        });
    });
}
